module.exports = {
  "Global.ui.detalhes": "Detalhes",
  "Global.ui.geral": "Geral",
  "Validacao.naoInformado": "Campo %s não informado|O campo %s não foi informado",
  "Validacao.valorForaDoIntervalo": "Valor inválido para o campo %s|O campo %s deve estar entre o intervalo de %s até %s",
  "Validacao.regraInvalida.igualdade": "Valor inválido para o campo %s|O campo %s deve ser igual a %s",
  "Validacao.regraInvalida.desigualdade": "Valor inválido para o campo %s|O campo %s deve ser diferente de %s",
  "Validacao.regraInvalida.maior": "Valor inválido para o campo %s|O campo %s deve ser maior que %s",
  "Validacao.regraInvalida.menor": "Valor inválido para o campo %s|O campo %s deve ser menor que %s",
  "Validacao.regraInvalida.maiorOuIgual": "Valor inválido para o campo %s|O campo %s deve ser maior ou igual a %s",
  "Validacao.regraInvalida.menorOuIgual": "Valor inválido para o campo %s|O campo %s deve ser menor ou igual a %s",
  "Estado": "Estado",
  "Estado.ID": "STUB:ID",
  "Estado.nome": "Nome|Nome do Estado",
  "Estado.sigla": "Sigla|Sigla do Estado",
  "Estado.codigoIBGE": "Código IBGE|Código do Estado na Tabela do IBGE.",
  "Estado.cidades": "STUB:cidades",
  "Estado.pessoasComIdentidadeExpedida": "STUB:pessoasComIdentidadeExpedida",
  "Estado.pessoasComInscricaoEstadualExpedida": "STUB:pessoasComInscricaoEstadualExpedida",
  "Estado.ui.filtroNome": "Nome",
  "Estado.ui.filtroEstado": "Estado",
  "Estado.ui.chooser.nome": "Nome:",
  "Estado.ui.filterItem.nome": "Nome:",
  "Estado.ui.filterItem.sigla": "Sigla:",
  "Estado.ui.filterItem.codigoIBGE": "Cód. IBGE:",
  "Estado.nome.invalido.duplicado": "Estado duplicado|Nome de Estado já cadastrado",
  "Estado.sigla.invalida.duplicada": "Sigla duplicada|Sigla do Estado já cadastrada.",
  "Estado.sigla.naoEncontrada": "Sigla do Estado inválida|Não é uma das siglas dos Estados brasileiros",
  "Estado.codigoIBGE.invalido": "Código IBGE do Estado inválido|Não é um Código registrado na Tabela IBGE",
  "Cidade": "Cidade",
  "Cidade.ID": "STUB:ID",
  "Cidade.nome": "Nome|Nome da Cidade",
  "Cidade.estado": "UF|UF da Cidade",
  "Cidade.codigoIBGE": "Código IBGE|Código do Município na Tabela do IBGE",
  "Cidade.enderecos": "STUB:enderecos",
  "CidadeDTO.estado": "Estado",
  "Cidade.ui.filtroNome": "Nome",
  "Cidade.ui.filtroEstado": "Estado",
  "Cidade.ui.chooser.nome": "Nome:",
  "Cidade.ui.filterItem.nome": "Nome:",
  "Cidade.ui.filterItem.sigla": "Sigla:",
  "Cidade.ui.filterItem.codigoIBGE": "Cód. IBGE:",
  "Cidade.nome.invalido.duplicado": "Nome inválido|Nome de Cidade já existente neste Estado.",
  "Cidade.codigoIBGE.invalido": "Código IBGE do Município inválido|Não é um Código registrado na Tabela IBGE",
  "Pessoa": "Pessoa",
  "Pessoa.ID": "STUB:ID",
  "Pessoa.status": "Status|Situação do cadastro da Pessoa",
  "Pessoa.status.A": "Ativo",
  "Pessoa.status.I": "Inativo",
  "Pessoa.nome": "Nome|Nome Completo da Pessoa Física ou Nome fantasia da Pessoa Jurídica",
  "Pessoa.tipo": "Tipo Pessoa|Pessoa Física ou Jurídica",
  "Pessoa.tipo.F": "Pessoa Fisíca",
  "Pessoa.tipo.J": "Pessoa Jurídica",
  "Pessoa.CPF": "CPF|Número do Cadastro da Pessoa Física",
  "Pessoa.dataNascimento": "Data de Nascimento|",
  "Pessoa.identidade": "RG|Número do Registro Geral",
  "Pessoa.siglaOrgaoIdentidade": "Órgão Expedidor|Sigla do Órgão Expedidor da Identidade",
  "Pessoa.sexo": "Sexo|Gênero da Pessoa Física",
  "Pessoa.sexo.N": "Não Especificado",
  "Pessoa.sexo.M": "Masculino",
  "Pessoa.sexo.F": "Feminino",
  "Pessoa.estadoCivil": "Estado Civil|Situação em relação ao matrimônio",
  "Pessoa.estadoCivil.N": "Não Especificado",
  "Pessoa.estadoCivil.S": "Solteiro",
  "Pessoa.estadoCivil.C": "Casado",
  "Pessoa.estadoCivil.D": "Divorciado",
  "Pessoa.estadoCivil.E": "Separado",
  "Pessoa.estadoCivil.V": "Viúvo",
  "Pessoa.estadoCivil.U": "União Estável",
  "Pessoa.estadoExpedidorIdentidade": "Estado Expedidor|Estado onde foi expedido a Identidade",
  "Pessoa.razaoSocial": "Razão Social|Nome de Registro da Pessoa Jurídica",
  "Pessoa.observacao": "STUB:observacao",
  "Pessoa.CNPJ": "CNPJ|Número do Cadastro Nacional da Pessoa Jurídica",
  "Pessoa.inscricaoEstadual": "Inscrição Estadual|Número da Inscrição Estadual",
  "Pessoa.ramoAtividade": "Ramo de atividade",
  "Pessoa.estadoExpedidorInscricaoEstadual": "Estado Expedidor I.E.|Estado onde foi expedido a Inscrição Estadual",
  "Pessoa.isentoInscricaoEstadual": "Isento Inscrição Estadual|Desobriga cadastro de Inscrição Estadual de Pessoas Jurídicas",
  "Pessoa.inscricaoMunicipal": "Inscrição Municipal|Número da Inscrição Municipal",
  "Pessoa.contatos": "STUB:contatos",
  "Pessoa.enderecos": "STUB:enderecos",
  "Pessoa.unidadesNegocio": "STUB:unidadesNegocio",
  "Pessoa.CPF.invalido": "CPF inválido|O CPF informado é inválido",
  "Pessoa.CPF.invalido.duplicado": "CPF já cadastrado|Há outra Pessoa com o CPF %s",
  "Pessoa.CPF.invalido.tipoPessoa": "Tipo de Pessoa inválido|Por ter CPF definido a Pessoa deve ser do Tipo Física",
  "Pessoa.dataNascimento.dataInvalida": "Data de Nascimento inválida|Deve ser menor que a Data atual",
  "Pessoa.CNPJ.invalido": "CNPJ inválido|O CNPJ informado é inválido",
  "Pessoa.CNPJ.invalido.duplicado": "CNPJ já cadastrado|Há outra Pessoa com o CNPJ %s",
  "Pessoa.CNPJ.invalido.tipoPessoa": "Tipo de Pessoa inválido|Por ter CNPJ definido a Pessoa deve ser do Tipo Jurídica",
  "Pessoa.inscricaoEstadual.invalida": "Inscrição Estadual inválida|A Inscrição Estadual informada é inválida para o Estado de Inscrição informado",
  "Pessoa.inscricaoEstadual.naoPermitido": "Inscrição Estadual preenchida indevidamente|Por ser Isento de Inscrição Estadual o número da inscrição não deve ser preenchido",
  "Pessoa.inscricaoEstadual.incompleta": "Inscrição Estadual incompleta|Devem ser preenchidos a Inscrição Estadual e o Estado Expedidor",
  "PessoaDTO.telefone": "Telefone",
  "PessoaDTO.celular": "Celular",
  "PessoaDTO.cidade": "Cidade",
  "PessoaDTO.uf": "Estado",
  "PessoaDTO.cep": "CEP",
  "Pessoa.ui.editor.documentacao": "Documentação",
  "Pessoa.ui.filtroStatus": "Status",
  "Pessoa.ui.filtroNome": "Nome",
  "Pessoa.ui.filtroRazaoSocial": "Razão Social",
  "Pessoa.ui.filtroDocumento": "Documento",
  "Pessoa.ui.filtroContato": "Contato",
  "Pessoa.ui.filtroEstado": "Estado",
  "Pessoa.ui.filtroCidade": "Cidade",
  "Pessoa.ui.filtroTipoPessoa": "Tipo Pessoa",
  "Pessoa.ui.chooser.nome": "Nome:",
  "Pessoa.ui.chooser.cpfCnpj": "CPF/CNPJ:",
  "Pessoa.ui.chooser.contato": "Contato(s):",
  "Pessoa.ui.filterItem.nome": "Nome:",
  "UnidadeNegocio": "Unidade de Negócio",
  "UnidadeNegocio.ID": "STUB:ID",
  "UnidadeNegocio.status": "Status|Situação da Unidade de Negócio. Inativar implica em parar a sincronização da base de dados",
  "UnidadeNegocio.status.A": "Ativo",
  "UnidadeNegocio.status.I": "Inativo",
  "UnidadeNegocio.codigo": "Código|Código único da Unidade de Negócio",
  "UnidadeNegocio.movimentaEstoque": "Movimenta Estoque|Define se a Unidade de Negócio faz movimentações de Estoque como Recebimento, Transferência, Venda, etc",
  "UnidadeNegocio.pessoa": "Pessoa|Cadastro de Pessoa que corresponde à Unidade de Negócio.",
  "UnidadeNegocio.adicional": "Adicional|Define se a Un. Negócio utiliza a representação da Pessoa Jurídica porém não é a correspondente principal. Utilizado em casos de Depósito/Armazém que possuem controle de Estoque independente porém utilizam uma mesma Pessoa Jurídica que a loja.",
  "UnidadeNegocio.grupoClienteAlpha7": "Grupo A7|Código do Grupo de Cliente que representa a Unidade de Negócio na Alpha7",
  "UnidadeNegocio.codigoClienteAlpha7": "Código A7|Código do Cliente que representa a Unidade de Negócio na Alpha7",
  "UnidadeNegocio.codigoClienteAlpha7.invalido.duplicado": "Código A7 da Un. Neg. duplicado|Já existe outra Un. Neg. com o Código A7 igual a %s",
  "UnidadeNegocio.grupoClienteAlpha7.invalido.duplicado": "Código e Grupo A7 da Un. Neg. duplicado|Já existe outra Un. Neg. com o Código e Grupo A7 igual a %s-%s",
  "UnidadeNegocioDTO.codigoClienteAlpha7": "Cód. A7",
  "UnidadeNegocioDTO.nome": "Nome",
  "UnidadeNegocioDTO.CNPJ": "CNPJ",
  "UnidadeNegocioDTO.telefone": "Telefone",
  "UnidadeNegocioDTO.cidade": "Cidade",
  "UnidadeNegocioDTO.estado": "Estado",
  "UnidadeNegocio.ui.editor.detalhesA7Pharma": "Detalhes A7Pharma",
  "UnidadeNegocio.ui.filtroStatus": "Status",
  "UnidadeNegocio.ui.filtroCodigoAlpha7": "Código A7",
  "UnidadeNegocio.ui.filtroRazaoSocial": "Razão Social",
  "UnidadeNegocio.ui.filtroCNPJ": "CNPJ",
  "UnidadeNegocio.ui.filtroContato": "Contato",
  "UnidadeNegocio.ui.filtroEstado": "Estado",
  "UnidadeNegocio.ui.filtroCidade": "Cidade",
  "UnidadeNegocio.ui.codigoA7": "Código A7",
  "UnidadeNegocio.ui.chooser.codigoA7": "Código A7:",
  "UnidadeNegocio.ui.chooser.nome": "Nome:",
  "UnidadeNegocio.ui.chooser.cnpj": "CNPJ:",
  "UnidadeNegocio.ui.filterItem.codigoA7": "Código A7:",
  "UnidadeNegocio.ui.filterItem.nome": "Nome:",
  "UnidadeNegocio.ui.filterItem.cnpj": "CNPJ:",
  "UnidadeNegocio.ui.MultipleFilterItem.codigoA7": "Código A7:",
  "UnidadeNegocio.ui.MultipleFilterItem.nome": "Nome:",
  "UnidadeNegocio.ui.MultipleFilterItem.cnpj": "CNPJ:",
  "ClassificacaoIndicador": "Classificação Indicador",
  "ClassificacaoIndicador.ID": "STUB:ID",
  "ClassificacaoIndicador.nome": "Nome|Nome da Classificação do Indicador",
  "ClassificacaoIndicador.tipo": "Tipo|Define o Tipo da Classificação como Departamento ou Perspectiva Administrativa",
  "ClassificacaoIndicador.tipo.?": "Não Especificado",
  "ClassificacaoIndicador.tipo.A": "Departamento",
  "ClassificacaoIndicador.tipo.B": "Gestão",
  "ClassificacaoIndicador.tipo.C": "Ramo de Atividade",
  "ClassificacaoIndicador.tipo.D": "Investimento",
  "ClassificacaoIndicador.folha": "Folha|Define se a Classificação é folha da Árvore em que está cadastrada",
  "ClassificacaoIndicador.profundidade": "Profundidade|Número da posição do galho/folha em relação ao tronco da Árvore",
  "ClassificacaoIndicador.caminho": "Caminho|Descrição do caminho das Classificações Superiores até a Classificação atual",
  "ClassificacaoIndicador.classificacaoIndicadorPai": "Classificação Pai|Classificação que está acima desta na hierarquia",
  "ClassificacaoIndicador.codigoA7": "Código A7|Código interno de cadastro da Classificação. Quando preenchido, indica que foi criada pela Alpha7.",
  "ClassificacaoIndicador.classificacoesFilhas": "STUB:classificacoesFilhas",
  "ClassificacaoIndicador.indicadoresDeGestao": "STUB:indicadoresDeGestao",
  "ClassificacaoIndicador.indicadoresDoDepartamento": "STUB:indicadoresDoDepartamento",
  "ClassificacaoIndicador.indicadoresDoRamoAtividade": "STUB:indicadoresDoRamoAtividade",
  "ClassificacaoIndicador.indicadoresDoInvestimento": "STUB:indicadoresDoInvestimento",
  "ClassificacaoIndicador.ui.chooser.caminho": "Caminho:",
  "ClassificacaoIndicador.ui.chooser.tipo": "Tipo:",
  "ClassificacaoIndicador.ui.filtroCaminho": "Caminho",
  "ClassificacaoIndicador.ui.filtroTipo": "Tipo",
  "ClassificacaoIndicador.ui.filtroFolha": "Somente folhas",
  "ClassificacaoIndicador.ui.filtroFolha.sim": "Sim",
  "ClassificacaoIndicador.ui.filtroFolha.nao": "Não",
  "ClassificacaoIndicador.ui.codigoA7": "Código A7",
  "ClassificacaoIndicador.nome.invalido.duplicado": "Nome da Classificação inválido|Para esta Classificação Pai já existe uma Classificação com esse nome",
  "ClassificacaoIndicador.tipo.invalido": "Tipo da Classificação inválido|O tipo dessa classificação é diferente do tipo de seu pai",
  "PainelMedicaoIndicador.ui.filtroNomeIndicador": "Nome Indicador",
  "PainelMedicaoIndicador.ui.filtroIndicador": "Indicador",
  "PainelMedicaoIndicador.ui.filtroTipoAvaliacao": "Avaliação",
  "PainelMedicaoIndicador.ui.filtroUnidadeNegocio": "Unid. Negócio",
  "PainelMedicaoIndicador.ui.filtroTipoGestao": "Tipo de Gestão",
  "PainelMedicaoIndicador.ui.filtroDepartamento": "Departamento",
  "PainelMedicaoIndicador.ui.filtroRamoAtividade": "Ramo Atividade",
  "PainelMedicaoIndicador.ui.filtroInvestimento": "Investimento",
  "PainelMedicaoIndicador.ui.filtroGrupoClienteAlpha7": "Grupo Cliente Alpha7",
  "PainelMedicaoIndicador.ui.botaoSair": "Sair",
  "PainelMedicaoIndicador.ui.mobile.arrayVazio": "Não há dados para exibir.",
  "PainelMedicaoIndicador.ui.modal.dicionario": "Dicionário",
  "PainelMedicaoIndicador.ui.modal.unidadeMedida": "Unidade de Medida:",
  "PainelMedicaoIndicador.ui.modal.desempenhoMinimo": "Desempenho Mínimo:",
  "PainelMedicaoIndicador.ui.modal.desempenhoMaximo": "Desempenho Máximo:",
  "PainelMedicaoIndicador.ui.modal.objetivo": "Objetivo",
  "PainelMedicaoIndicador.ui.modal.procedimento": "Procedimento",
  "PainelMedicaoIndicador.ui.modal.risco": "Risco",
  "PainelMedicaoIndicador.ui.modal.avaliacao": "Avaliação",
  "PainelMedicaoIndicador.ui.modal.historico": "Histórico",
  "PainelMedicaoIndicador.muitosRegistrosRetornados": "Limite de registros excedido|O limite de dez mil registros foi atingido, recomendamos<br/>que filtre melhor os dados ou altere o nível de detalhamento",
  "FonteDados": "FonteDados",
  "FonteDados.status": "Status|Define se o registro está ativa ou inativa",
  "FonteDados.status.A": "Ativo",
  "FonteDados.status.I": "Inativo",
  "FonteDados.nome": "Nome|Nome que identifique de maneira simples o registro",
  "FonteDados.tabela": "Tabela|Nome da tabela no banco de dados de destino",
  "FonteDados.conexaoBancoDados": "Conexão BD|Conexão do banco de dados para armazenamento dos dados extraídos",
  "FonteDados.regraAtualizacao": "Regra Atualização|Define as regras de intervalos de atualização dos dados",
  "FonteDados.categoriaCliente": "Categoria de Cliente|Define qual a Categoria de Cliente que se aplica a extração dos dados, evitando extrair informações de clientes indevidos.",
  "FonteDados.ui.filtroNome": "Nome",
  "FonteDados.ui.filtroStatus": "Status",
  "FonteDados.ui.filtroTabela": "Tabela",
  "FonteDados.ui.filtroConexaoBancoDados": "Conexão Banco de Dados",
  "FonteDados.ui.filtroCategoriaCliente": "Categoria Cliente",
  "FonteDados.ui.filterItem.nome": "Nome:",
  "FonteDados.ui.actionConsultas": "Consultas",
  "FonteDados.controleAtualizacaoFonteDados": "STUB:controleAtualizacaoFonteDados",
  "FonteDadosDTO.conexaoBancoDados": "Conexão",
  "FonteDadosDTO.categoriaCliente": "Categoria de Cliente",
  "FonteDadosConsulta": "FonteDadosConsulta",
  "FonteDadosConsulta.fonteDados": "Fonte de Dados|Fonte de Dados relacionado a consulta",
  "FonteDadosConsulta.status": "Status|Define se a Consulta está ativa ou inativa",
  "FonteDadosConsulta.status.A": "Ativo",
  "FonteDadosConsulta.status.I": "Inativo",
  "FonteDadosConsulta.versao": "Versão|Versão da consulta, incrementada conforme necessário efetuar alguma alteração para ajuste.",
  "FonteDadosConsulta.consultaSQL": "Consulta SQL|Consulta no padrão SQL para retornar os dados do cubo. Parâmetros obrigatórios na consulta: :dataInicial e no caso de fonte de dados com Conexão ClickHouse também é obrigatório informar um campo com o parâmetro :fonteDadosID",
  "FonteDadosConsulta.versaoBancoDados": "Versão Banco de dados|Versão mínima do banco de dados que sistema do cliente deve ter para executar a consulta",
  "FonteDadosConsulta.ui.titleFonteDados": "Fonte de Dados:",
  "FonteDadosConsulta.ui.consultaDuplicada": "Consulta duplicada|Já existe consulta cadastrada com a versão %s e versão de banco de dados %s.",
  "FonteDadosConsulta.consultaSQL.invalida": "Consulta SQL|Consulta inválida, não é permitido o uso de operadores de CAST \"::\", ao invés disso use cast(campo as tipo).",
  "FonteDadosConsulta.consultaSQL.invalida.semParametroDataInicial": "Consulta SQL inválida|A consulta precisa ter o parâmetro :dataInicial",
  "FonteDadosConsulta.consultaSQL.invalida.parametroDataInicialInvalido": "Consulta SQL inválida|Foram encontradas ocorrências do parâmetro :dataInicial.\nO preenchimento do parâmetro é case sensitive, confira\nse a grafia está correta em todas as ocorrências",
  "FonteDadosConsulta.consultaSQL.invalida.semParametroFonteDadosID": "Consulta SQL inválida|Quando a fonte de dados tiver uma conexão ClickHouse é obrigatório ter o parâmetro :fonteDadosID",
  "FonteDadosConsulta.consultaSQL.invalida.parametroFonteDadosIDInvalido": "Consulta SQL inválida|Foram encontradas ocorrências do parâmetro :fonteDadosID.\nO preenchimento do parâmetro é case sensitive, confira\nse a grafia está correta em todas as ocorrências",
  "Indicador": "Indicador",
  "Indicador.ID": "ID",
  "Indicador.status": "Status|Situação atual do Indicador. Caso inativo, o cálculo das medições será interrompido.  Indicador.status.A=Ativo",
  "Indicador.status.A": "Ativo",
  "Indicador.status.I": "Inativo",
  "Indicador.nome": "Nome|Nome que identifique de maneira simples o Indicador",
  "Indicador.objetivo": "Objetivo|Descrição do que se pretende alcançar e por qual motivo",
  "Indicador.procedimento": "Procedimento|Especifica a ação que deverá ser feita para melhorar o desempenho do Indicador",
  "Indicador.risco": "Risco|Detalhamento das possíveis consequências caso o Indicador tenha baixo desempenho",
  "Indicador.classificacaoDepartamento": "Classif. Depto.|Classificação do Indicador relacionada ao Departamento responsável",
  "Indicador.classificacaoGestao": "Classif. Gestão|Classificação do Indicador relacionada a Gestão Administrativa, ou seja, como o Indicador é visto pelo ponto de vista Administrativo",
  "Indicador.classificacaoRamoAtividade": "Classif. Ramo de Atividade|Classificação do Indicador relacionada ao Ramo de Atividade, ou seja, para qual ramo o Indicador é relacionado",
  "Indicador.classificacaoInvestimento": "Classif. Investimento|Classificação do Indicador relacionada ao investimento necessário para efetuar melhorar seu desempenho. As vezes é necessário contratar um serviço de terceiro, pagar uma mensalidade, adquirir um equipamento, customizar o software entre outras formas de investimento.",
  "Indicador.desempenhoMinimo": "Desempenho Mín.|Define o menor valor desejável para o desempenho do Indicador, não sendo necessariamente o menor valor possível.",
  "Indicador.desempenhoMaximo": "Desempenho Máx.|Define o maior valor desejável para o desempenho do Indicador, não sendo necessariamente o maior valor possível.",
  "Indicador.desempenhoMelhor": "Melhor Desempenho|Define se é melhor que o resultado seja um número Maior ou Menor. Ex.: Lucro é algo que se deseja ser maior, Prejuízo é desejável que seja menor.",
  "Indicador.desempenhoMelhor.A": "Resultado maior",
  "Indicador.desempenhoMelhor.B": "Resultado menor",
  "Indicador.medicaoTipoUnidadeNegocio": "Tipo Un. Neg.|Define para quais Tipos de Un. Neg. serão calculadas as medições do Indicador: Todas, Central (servidor de sincronização) ou somente as que Movimentam Estoque.",
  "Indicador.medicaoTipoUnidadeNegocio.A": "Todas",
  "Indicador.medicaoTipoUnidadeNegocio.B": "Central",
  "Indicador.medicaoTipoUnidadeNegocio.C": "Movimenta estoque",
  "Indicador.medicaoTipoResultado": "Tipo Resultado|Define o Tipo de Resultado da Medição: Numérico ou Boolean (1 ou 0 / Verdadeiro ou Falso)",
  "Indicador.medicaoTipoResultado.B": "Booleano",
  "Indicador.medicaoTipoResultado.P": "Porcentagem",
  "Indicador.medicaoTipoResultado.M": "Número positivo",
  "Indicador.medicaoTipoResultado.N": "Número",
  "Indicador.medicaoAceitaResultadoNulo": "Aceita Resultado Nulo|Define se o cálculo de medição do Indicador permitirá resultados nulos. O nulo é representado pela avaliação \"Não se aplica\", que será utilizado em casos em que não se  pode constatar VERDADEIRO nem FALSO pois não faz sentido em determinado cenário. Ex: suponhamos que determinado recurso do sistema só seja possível de se usar no estado de SP: para as medições em Un. Neg. fora deste estado, o resultado deve ser nulo, pois \"Não se aplica\". Isso permitirá uma avaliação de quantas empresas usam o recursos, quantas não usam e quantas não podem usar.",
  "Indicador.medicaoUnidadeMedida": "Un. Medida|Unidade de Medida do Resultado: %, R$, Qtd. V/F etc",
  "Indicador.medicaoIntervaloEmMinutos": "Intervalo (Minutos)|Define a cada quanto tempo será executado a medição do Indicador. O aconselhado é que seja um intervalo máximo aceitável, caso seja um processo, um intervalo máximo de atraso aceitável. Padrão deve ser 1 dia (1440 min.)",
  "Indicador.codigoA7": "Código A7|Código interno de cadastro do Indicador. Quando preenchido, indica que o Indicador foi criado pela Alpha7.",
  "Indicador.versaoSistema": "Versão Sistema|Versão do sistema na qual foi disponibilizado o recurso medido pelo indicador",
  "Indicador.medicoes": "Medições",
  "Indicador.errosMedicoes": "Erros de medição",
  "Indicador.consultas": "Consultas",
  "Indicador.classificacaoDepartamento.invalida.tipo": "Classificação Departamento inválida|Classificação informada não é do tipo Departamento.",
  "Indicador.classificacaoDepartamento.invalida.folha": "Classificação Departamento inválida|Classificação informada não é Folha.",
  "Indicador.classificacaoGestao.invalida.tipo": "Classificação Gestão inválida|Classificação informada não é do tipo Gestão.",
  "Indicador.classificacaoGestao.invalida.folha": "Classificação Gestão inválida|Classificação informada não é Folha.",
  "Indicador.classificacaoRamoAtividade.invalida.tipo": "Classificação Ramo de Atividade inválida|Classificação informada não é do tipo Ramo de Atividade.",
  "Indicador.classificacaoRamoAtividade.invalida.folha": "Classificação Ramo de Atividade inválida|Classificação informada não é Folha.",
  "Indicador.classificacaoInvestimento.invalida.tipo": "Classificação Investimento inválida|Classificação informada não é do tipo Investimento.",
  "Indicador.classificacaoInvestimento.invalida.folha": "Classificação Investimento inválida|Classificação informada não é Folha.",
  "Indicador.codigoA7.invalido.duplicado": "Código A7 existente|Código A7 já está sendo utilizado por outro indicador.",
  "Indicador.desempenhoMinimo.invalida.tipoBoolean": "Campo Desempenho Mínimo inválido|O campo Tipo Resultado da medição estão configurado como Booleano e, portanto, Desempenho mínimo deve ser zero.",
  "Indicador.desempenhoMaximo.invalida.tipoBoolean": "Campo Desempenho Máximo inválido|O campo Tipo Resultado da medição estão configurado como Booleano e, portanto, Desempenho Máximo deve ser Um.",
  "Indicador.ui.filtroNome": "Nome",
  "Indicador.ui.filtroDepartamento": "Departamento",
  "Indicador.ui.filtroGestao": "Gestão",
  "Indicador.ui.filtroRamoAtividade": "Ramo de Atividade",
  "Indicador.ui.filtroInvestimento": "Investimento",
  "Indicador.ui.filtroStatus": "Status",
  "Indicador.ui.filtroVersaoSistema": "Versão Sistema",
  "Indicador.ui.actionConsultas": "Consultas",
  "Indicador.ui.classificacao": "Classificação",
  "Indicador.ui.medicoes": "Medições",
  "Indicador.ui.desempenho": "Desempenho",
  "Indicador.ui.dicionario": "Dicionário",
  "IndicadorConsulta": "IndicadorConsulta",
  "IndicadorConsulta.ID": "ID",
  "IndicadorConsulta.status": "Status|Define se a Consulta de medição do Indicador está ativa ou inativa",
  "IndicadorConsulta.status.?": "Descrição do Valor",
  "IndicadorConsulta.status.A": "Ativo",
  "IndicadorConsulta.status.I": "Inativo",
  "IndicadorConsulta.indicador": "Indicador|Indicador relacionado a Consulta de medição",
  "IndicadorConsulta.versao": "Versão|Versão da consulta da medição do indicador, incrementada conforme necessário efetuar alguma alteração para ajuste.",
  "IndicadorConsulta.consultaSQL": "Consulta SQL|Consulta no padrão SQL para retornar os dados da medição. Deverá retornar: Data, Un. Neg., Valor. Poderão ser utilizados parâmetros na consulta: ${ID_UNIDADENEGOCIO} ${DATA}",
  "IndicadorConsulta.versaoBancoDados": "Versão Banco de dados|Versão mínima do banco de dados que sistema do cliente deve ter para medir os indicadores",
  "IndicadorConsulta.ui.titleIndicador": "Indicador:",
  "IndicadorConsulta.ui.consultaDuplicada": "Item duplicado|Já existe item cadastrado com a versão %s na versão %s do banco de dados para este indicador.",
  "IndicadorConsulta.consultaSQL.invalida": "Consulta SQL|Consulta inválida, não é permitido o uso de operadores de CAST \"::\", ao invés disso use cast(campo as tipo).",
  "RegraAtualizacaoFonteDados": "RegraAtualizacaoFonteDados",
  "RegraAtualizacaoFonteDados.ID": "STUB:ID",
  "RegraAtualizacaoFonteDados.nome": "Nome|Nome que identifique de maneira simples o registro",
  "RegraAtualizacaoFonteDados.fontesDados": "STUB:fontesDados",
  "RegraAtualizacaoFonteDados.itens": "STUB:itens",
  "RegraAtualizacaoFonteDados.ui.actionItens": "Itens",
  "RegraAtualizacaoFonteDados.ui.filtroNome": "Nome",
  "RegraAtualizacaoFonteDados.ui.chooser.nome": "Nome:",
  "RegraAtualizacaoFonteDadosItem": "Item da Regra de Atualizacao de Fonte de Dados",
  "RegraAtualizacaoFonteDadosItem.regraAtualizacaoFonteDados": "Regra de Atualização|Referente ao item",
  "RegraAtualizacaoFonteDadosItem.diasHistorico": "Dias de Histórico|Indica quantos dias de histórico a fonte de dados irá enviar para o servidor no intervalo especificado",
  "RegraAtualizacaoFonteDadosItem.intervalo": "Intervalo|Define o intervalo ou frequência da atualização da fonte de dados.",
  "RegraAtualizacaoFonteDadosItem.tipoIntervalo": "Tipo Intervalo|Define o Tipo de intervalo da atualização da fonte de dados. Ex.: Minuto, Dia, Ano.",
  "RegraAtualizacaoFonteDadosItem.tipoIntervalo.?": "Não Especificado",
  "RegraAtualizacaoFonteDadosItem.tipoIntervalo.A": "Minuto",
  "RegraAtualizacaoFonteDadosItem.tipoIntervalo.B": "Dia",
  "RegraAtualizacaoFonteDadosItem.tipoIntervalo.C": "Ano",
  "RegraAtualizacaoFonteDadosItem.tipoIntervalo.D": "Único",
  "RegraAtualizacaoFonteDadosItem.tipoEnvio": "Tipo de Envio|Define o Tipo de Envio durante a atualização da Fonte de Dados, se será feita um único envio Integral ou diversos envios de forma Parcial, útil para extrações de grandes intervalos.",
  "RegraAtualizacaoFonteDadosItem.tipoEnvio.?": "Não Especificado",
  "RegraAtualizacaoFonteDadosItem.tipoEnvio.I": "Integral",
  "RegraAtualizacaoFonteDadosItem.tipoEnvio.P": "Parcial",
  "RegraAtualizacaoFonteDadosItem.envioParcialDias": "Dias para Envio Parcial|Define a quantidade de dias que será considerada em cada Envio Parcial",
  "RegraAtualizacaoFonteDadosItem.controleAtualizacaoFonteDados": "Controles de Atualização de Fonte de Dados|Controles de Atualização relacionados ao Item da Regra de Atualização",
  "RegraAtualizacaoFonteDadosItem.ui.titleFonteDados": "Regra de Atualização:",
  "RegraAtualizacaoFonteDadosItem.ui.itemDuplicado": "Item duplicado|Já existe item cadastrado com a quantidade %s de Dias de Histórico.",
  "ControleAtualizacaoFonteDados": "Controle de Atualizacao de Fonte de Dados",
  "ControleAtualizacaoFonteDados.fonteDados": "Fonte Dados|Fonte de Dados que foi atualizada",
  "ControleAtualizacaoFonteDados.grupoClienteAlpha7": "Grupo Alpha7|Código do Grupo de Cliente que representa a Unidade de Negócio na Alpha7",
  "ControleAtualizacaoFonteDados.codigoClienteAlpha7": "Código Alpha7|Código do Cliente que representa a Unidade de Negócio na Alpha7",
  "ControleAtualizacaoFonteDados.regraAtualizacaoFonteDadosItem": "Item da Regra de Atualização|Item que foi atualizado",
  "ControleAtualizacaoFonteDados.parametroDataInicial": "Parâmetro Data Inicial|Data Inicial de corte utilizada na extração dos dados",
  "ControleAtualizacaoFonteDados.parametroDataFinal": "Parâmetro Data Final|Data Final de corte utilizada na extração dos dados",
  "ControleAtualizacaoFonteDados.envioParcial": "Envio Parcial|Indicador se o último envio realizado foi parcial. Caso o envio seja parcial a Data Final será preenchida, mesmo que o envio seja parcial, ao finalizar o envio do período todo, este campo será marcado como false, para indicar que não é necessário mais realizar nenhum envio adicional",
  "ControleAtualizacaoFonteDados.dataHoraUltima": "Última Data Hora|Última vez que houve atualização dos dados",
  "ControleAtualizacaoFonteDados.dataHoraPrimeira": "Primeira Data Hora|Primeira vez que houve atualização dos dados",
  "ControleAtualizacaoFonteDados.quantidade": "Quantidade|Total de vezes que ocorreram a atualização dos dados",
  "ControleAtualizacaoFonteDados.ui.filtroCodigoClienteAlpha7": "Código A7",
  "ControleAtualizacaoFonteDados.ui.filtroFonteDados": "Fonte de Dados",
  "ControleAtualizacaoFonteDados.ui.filtroDataHoraUltima": "Última Data Hora",
  "ControleAtualizacaoFonteDadosDTO.codigoClienteAlpha7": "Código A7",
  "ControleAtualizacaoFonteDadosDTO.fonteDados": "Fonte de Dados",
  "ControleAtualizacaoFonteDadosDTO.diasHistorico": "Dias de Histórico|Indica quantos dias de histórico a fonte de dados irá enviar para o servidor no intervalo especificado",
  "ControleAtualizacaoFonteDadosDTO.envioParcialDias": "Dias para Envio Parcial|Define a quantidade de dias que será considerada em cada Envio Parcial",
  "Visao": "Visao",
  "Visao.ID": "STUB:ID",
  "Visao.status": "Status|Define se o registro está ativo ou inativo",
  "Visao.status.A": "Ativo",
  "Visao.status.I": "Inativo",
  "Visao.nome": "Nome|Nome da Visão de Dados",
  "Visao.classificacaoDepartamento": "Classif. Depto.|Classificação relacionada ao Departamento responsável",
  "Visao.metaDados": "Meta Dados|Este campo deve conterá um texto no formato JSON dos meta dados da visão. Dados que serão armazenados: descrição do coluna da visão, formato: (porcentagem, moeda, decimal, inteiro), melhor resultado: (maior melhor ou menor melhor), SQL: fórmula do cálculo da coluna no formato SQL",
  "Visao.tabela": "Tabela|Tabela que armazena os dados onde a visão será consultada",
  "Visao.tabela.?": "Não Informado",
  "Visao.tabela.A": "Análise Geral",
  "Visao.nome.duplicado": "Visão Duplicada|Já existe uma Visão com o nome informado.",
  "Visao.metaDados.invalido": "Campo Metadados Inválido|Metadados inválidos. Verifique os seguintes elementos: %s.",
  "Visao.metaDados.vazio": "Campo Metadados Inválido|O campo metadados é obrigatório.",
  "Visao.metaDados.descricao": "Descrição",
  "Visao.metaDados.formato": "Formato",
  "Visao.metaDados.melhorResultado": "Melhor Resultado",
  "Visao.metaDados.sql": "SQL",
  "Visao.metaDados.detalheFormato": "Detalhe: Formato",
  "Visao.metaDados.erroConversao": "Formato inválido|Formato inválido, verifique os campos informados.",
  "Visao.ui.filtroStatus": "Status",
  "Visao.ui.filtroDepartamento": "Departamento",
  "Visao.ui.filtroNome": "Nome",
  "Visao.ui.filterItem.nome": "Nome",
  "PainelAnalise.ui.arrayVazio": "Não há dados para exibir.",
  "PainelAnalise.ui.filterBandSubtitle": "Intervalo:",
  "PainelAnalise.ui.filtroUnidadeNegocio": "Unidade de Negócio",
  "PainelAnalise.ui.filtroVisao": "Visão",
  "PainelAnalise.ui.filtroGrupoClienteAlpha7": "Grupo Cliente Alpha7",
  "PainelAnalise.visaoConfiguracoes.periodo.titulo": "Período",
  "PainelAnalise.visaoConfiguracoes.periodo.A": "Dia",
  "PainelAnalise.visaoConfiguracoes.periodo.B": "Semana",
  "PainelAnalise.visaoConfiguracoes.periodo.C": "Mês",
  "PainelAnalise.visaoConfiguracoes.periodo.D": "Trimestre",
  "PainelAnalise.visaoConfiguracoes.periodo.E": "Semestre",
  "PainelAnalise.visaoConfiguracoes.periodo.F": "Ano",
  "PainelAnalise.visaoConfiguracoes.comparador.titulo": "Comparação",
  "PainelAnalise.visaoConfiguracoes.comparador.A": "Período Anterior",
  "PainelAnalise.visaoConfiguracoes.comparador.B": "Ano passado",
  "PainelAnalise.visaoConfiguracoes.intervalo.titulo": "Intervalo",
  "PainelAnalise.visaoConfiguracoes.intervalo.A": "Em andamento",
  "PainelAnalise.visaoConfiguracoes.intervalo.B": "Inteiro",
  "Organizacao": "Organizacao",
  "Organizacao.nome": "Nome|Nome da Organização",
  "Organizacao.pessoa": "Pessoa|Pessoa da Organização",
  "Organizacao.dataHoraInclusao": "Data Hora Inclusão|Data Hora em que o cadastro da organização foi incluído",
  "Organizacao.ui.filtroNome": "Nome",
  "Organizacao.ui.filtroDocumento": "Documento",
  "Organizacao.ui.chooser.nome": "Nome:",
  "Organizacao.ui.chooser.cpfCnpj": "CPF/CNPJ:",
  "Usuario": "Usuario",
  "Usuario.organizacao": "Organização|Organização da qual o usuário pertence",
  "Usuario.email": "E-mail|E-mail do Usuário, será utilizado para comunicação e login",
  "Usuario.senha": "Senha|Senha do usuário em forma de Código Hash",
  "Usuario.status": "Status|Define a situação do Usuário",
  "Usuario.status.A": "Ativo",
  "Usuario.status.I": "Inativo",
  "Usuario.apelido": "Apelido|Nome abreviado do Usuário de rápida identificação",
  "Usuario.pessoa": "Pessoa|Pessoa Física referente ao Usuário. Utilizado para armazenar dados pessoais do Usuário",
  "UsuarioDTO.organizacao": "Organização",
  "Usuario.duplicado": "Usuário duplicado|Já existe um usuário cadastrado com este e-mail",
  "Usuario.email.invalido": "E-mail inválido|O E-mail informado possui um formato inválido",
  "Usuario.ui.filtroStatus": "Status",
  "Usuario.ui.filtroEmail": "E-mail",
  "Usuario.ui.filtroApelido": "Apelido",
  "Usuario.ui.filtroOrganizacao": "Organização",
  "Usuario.ui.actionEquipes": "Equipes",
  "Usuario.ui.chooser.apelido": "Apelido:",
  "Usuario.ui.chooser.email": "e-mail:",
  "Usuario.invalido": "Usuário inválido|Login e/ou senha incorretos",
  "Seguranca.sessaoUsuarioInvalida": "Sessão de Usuário inválida|Não foi encontrada Sessão de Usuário ativa correspondente ao\nidentificador de sessão atual.\n\nEfetue o Login novamente, ou contate o administrador do sistema\n para maiores informações.",
  "Equipe": "Equipe",
  "Equipe.organizacao": "Organização|Organização a qual a Equipe pertence",
  "Equipe.nome": "Nome|Nome da Equipe",
  "Equipe.nome.duplicado": "Equipe duplicada|Já existe uma equipe com este nome cadastrada",
  "Equipe.ui.filtroNome": "Nome",
  "Equipe.ui.actionUsuarios": "Usuários",
  "EquipeUsuario": "Equipe Usuário",
  "EquipeUsuario.ui.equipeUsuario.title": "Equipe:",
  "EquipeUsuario.ui.actionIncluir": "Incluir",
  "EquipeUsuario.ui.actionExcluir": "Excluir",
  "EquipeUsuario.ui.confirmarExclusao": "Confirmar exclusão|Deseja realmente excluir esse registro?",
  "UsuarioEquipe.ui.usuarioEquipe.title": "Usuário:",
  "UsuarioEquipe.ui.actionIncluir": "Incluir",
  "UsuarioEquipe.ui.actionExcluir": "Excluir",
  "UsuarioEquipe.ui.confirmarExclusao": "Confirmar exclusão|Deseja realmente excluir esse registro?",
  "Permissao": "Permissão",
  "Permissao.nivel": "Nível|Define o nível de acesso da permissão",
  "Permissao.nivel.?": "Não Especificado",
  "Permissao.nivel.A": "Todos os Usuários",
  "Permissao.nivel.B": "Organização",
  "Permissao.nivel.C": "Equipe",
  "Permissao.nivel.D": "Usuário",
  "Permissao.nivelOrganizacao": "Organização|Organização que terá acesso à permissão",
  "Permissao.nivelEquipe": "Equipe|Equipe que terá acesso à permissão",
  "Permissao.nivelUsuario": "Usuário|Usuário que terá acesso à permissão",
  "Permissao.finalidade": "Finalidade|Define o objetivo da permissão: Visualizar ou acessar recursos",
  "Permissao.finalidade.?": "Não Especificada",
  "Permissao.finalidade.A": "Visualizar Un. Neg.",
  "Permissao.finalidade.B": "Visualizar Departamento",
  "Permissao.finalidade.C": "Acessar Recurso",
  "Permissao.opcaoUnidadeNegocio": "Opção Un. Neg.|Define qual será nível de visualização a ser permitido: Todas, Grupo de Cliente ou uma Un. Neg. específica",
  "Permissao.opcaoUnidadeNegocio.?": "Não Especificado",
  "Permissao.opcaoUnidadeNegocio.A": "Todas",
  "Permissao.opcaoUnidadeNegocio.B": "Grupo Cliente Alpha7",
  "Permissao.opcaoUnidadeNegocio.C": "Específica",
  "Permissao.opcaoUnidadeNegocioGrupoClienteAlpha7": "Grupo Cliente|Código do Grupo de Cliente que poderá ser visualizado",
  "Permissao.unidadeNegocio": "Un. Neg.|Unidade de Negócio que poderá ser visualizada",
  "Permissao.opcaoDepartamento": "Opção Depto.|Define qual será nível de visualização a ser permitido: Todos ou um Departamento específico",
  "Permissao.opcaoDepartamento.?": "Não Especificado",
  "Permissao.opcaoDepartamento.A": "Todos",
  "Permissao.opcaoDepartamento.B": "Específico",
  "Permissao.classificacaoDepartamento": "Departamento|Departamento que poderá ser visualizado",
  "Permissao.opcaoRecurso": "Opção Recurso|Define qual será o nível de acesso a ser permitido: Todos os recursos ou um em específico",
  "Permissao.opcaoRecurso.?": "Não Especificado",
  "Permissao.opcaoRecurso.A": "Todos",
  "Permissao.opcaoRecurso.B": "Específico",
  "Permissao.opcaoRecursoChave": "Recurso|Chave do Recurso que poderá ser acessado",
  "Permissao.opcaoRecursoValor": "Valor|Valor relacionado à Chave do Recurso que poderá ser acessado",
  "Permissao.restringir": "Restringir|Esta opção inverte a permissão, negando o acesso/visualização",
  "Permissao.usuarioInclusao": "Usuário Inclusão|Usuário responsável pela inclusão do registro",
  "Permissao.dataHoraInclusao": "Data Hora Inclusão|Data e hora da inclusão do registro",
  "PermissaoDTO.detalheNivel": "Detalhe Nível",
  "PermissaoDTO.descricaoOpcao": "Opção",
  "PermissaoDTO.detalheOpcao": "Detalhe Opção",
  "Permissao.ui.filtroFinalidade": "Finalidade",
  "Permissao.ui.filtroOrganizacao": "Organização",
  "Permissao.ui.filtroEquipe": "Equipe",
  "Permissao.ui.filtroUsuario": "Usuário",
  "VisaoEvolucao.tipo.A": "Dia",
  "VisaoEvolucao.tipo.B": "Semana",
  "VisaoEvolucao.tipo.C": "Mês",
  "VisaoEvolucao.tipo.D": "Trimestre",
  "VisaoEvolucao.tipo.E": "Ano",
  "A7Dashboard.ui.filtroUnidadeNegocio": "Unidade Negócio",
  "A7Dashboard.ui.filtroGrupoClienteAlpha7": "Grupo Cliente Alpha7",
  "SessaoUsuario": "Sessão do Usuário",
  "SessaoUsuario.usuario": "Usuário|Usuário que abriu uma sessão, ou seja, logou no sistema",
  "SessaoUsuario.dataHora": "Data Hora|Data e Hora do início da Sessão do Usuário",
  "SessaoUsuario.tipo": "Tipo de Sessão do Usuário|Identifica o Tipo de Sessão do Usuárioor",
  "SessaoUsuario.tipo.?": "Não Especificado",
  "SessaoUsuario.tipo.A": "Sistema",
  "SessaoUsuario.tipo.B": "Usuário",
  "CacheSessaoUsuario": "Cache de Sessão do Usuário",
  "CacheSessaoUsuario.sessaoUsuario": "Sessão Usuário|Sessão do Usuário em cache",
  "CacheSessaoUsuario.cache": "Cache|Dados do cache da Sessão do Usuário",
  "FonteDadosArquivo": "Fonte de Dados Arquivo",
  "FonteDadosArquivo.grupoCliente": "Grupo Alpha7|Código do Grupo de Cliente na Alpha7",
  "FonteDadosArquivo.dataHoraExtracao": "Data Hora Extração|Data e Hora de extração dos dados do arquivo no servidor de extração",
  "FonteDadosArquivo.parametroDataInicial": "Parâmetro Data Inicial|Data Inicial de corte utilizada na extração dos dados",
  "FonteDadosArquivo.parametroDataFinal": "Parâmetro Data Final|Data Final de corte utilizada na extração dos dados",
  "FonteDadosArquivo.fonteDados": "Fonte de Dados|Fonte de dados referente",
  "FonteDadosArquivo.fonteDadosVersao": "Versão Fonte de Dados|Versão da consulta utilizada na extração dos dados",
  "FonteDadosArquivo.processamentoStatus": "Status Processamento|Situação do processamento do Arquivo",
  "FonteDadosArquivo.processamentoStatus.A": "Pendente",
  "FonteDadosArquivo.processamentoStatus.B": "Realizado",
  "FonteDadosArquivo.processamentoStatus.C": "Falha",
  "FonteDadosArquivo.processamentoErro": "Erro Processamento|Detalhes do Erro de processamento do arquivo",
  "FonteDadosArquivo.arquivo": "Arquivo|Conteúdo do Arquivo",
  "FonteDadosArquivo.dataHoraInclusao": "Data Hora Inclusão|Data e Hora de inclusão do arquivo no servidor de processamento",
  "FonteDadosArquivo.enderecoIPOrigem": "Endereço IP Origem|Endereço IP do servidor que transmitiu o arquivo",
  "FonteDadosArquivo.processamentoBytes": "Bytes Processados|Quantidade de bytes processados durante a transmissão do arquivo para o destino",
  "FonteDadosArquivo.processamentoLinhas": "Linhas Processadas|Quantidade de linhas processadas durante a transmissão do arquivo para o destino",
  "ConexaoBancoDados": "Conexão de Banco de Dados",
  "ConexaoBancoDados.ID": "ID",
  "ConexaoBancoDados.nome": "Nome|Nome de identificação o Local de Armazenamento",
  "ConexaoBancoDados.tipoBancoDados": "Tipo Banco de Dados|Tipo do Banco de Dados que será utilizado para o armazenamento",
  "ConexaoBancoDados.tipoBancoDados.?": "Não especificado",
  "ConexaoBancoDados.tipoBancoDados.A": "PostgreSQL",
  "ConexaoBancoDados.tipoBancoDados.B": "ClickHouse",
  "ConexaoBancoDados.nomeBancoDados": "Nome Banco de Dados|Nome do Banco de Dados para efetuar a conexão",
  "ConexaoBancoDados.host": "Host|Endereço para a conexão com o banco de dados",
  "ConexaoBancoDados.porta": "Porta|Porta de conexão no banco de dados",
  "ConexaoBancoDados.usuario": "Usuário|Usuário para a conexão com o banco de dados",
  "ConexaoBancoDados.senha": "Senha|Senha para a conexão com o banco de dados",
  "ConexaoBancoDados.ui.filtroNome": "Nome",
  "ConexaoBancoDados.ui.chooser.nome": "Nome:",
  "FonteDadosArquivo.recepcao.grupoClienteInvalido": "Falha ao salvar arquivo recebido|O Grupo de Cliente Alpha7 informado (%s) é inválido para o Código de cliente (%s).\nProvável configuração de código duplicada com outro grupo de cliente, entrar em contato com a equipe de manutenção.",
  "FonteDadosArquivo.recepcao.falhaAoSalvarArquivo": "Falha ao salvar arquivo recebido|Ocorreu um erro inesperado ao salvar o aquivo: %d",
  "FonteDadosAquivo.envio.clickhouse.timeoutAoInvocarClickHouseClient": "Timeout ao invocar o clickhouse-client|A execução do clickhouse-client demorou mais que o tempo esperado (5 minutos)",
  "FonteDadosAquivo.envio.clickhouse.falhaAoInvocarClickHouseClient": "Falha ao invocar o clickhouse-client|O clickhouse-client retornou um exit code diferente de 0: %s",
  "CategoriaCliente": "Categoria de Cliente",
  "CategoriaCliente.ID": "ID",
  "CategoriaCliente.nome": "Nome|Nome que identifica a Categoria do Cliente",
  "CategoriaCliente.grupoClienteAplicavel": "Grupo de Cliente Aplicável|Informar os códigos de Grupos de Clientes A7 separados por vírgula que se aplicam a essa Categoria de Cliente. Caso fique em branco todos os clientes (grupos) se aplicam.",
  "CategoriaCliente.aplicavelTodos": "Aplicável a todos|Define que a Categoria de cliente é aplicável a todos os grupos de cliente",
  "CategoriaCliente.grupoClienteAplicavel.invalido": "Grupo de Cliente Aplicável inválido|Deve conter apenas números (código de Grupos de Clientes A7) separados povírgula",
  "CategoriaCliente.grupoClienteAplicavel.preenchidoQuandoTodos": "Grupo de Cliente Aplicável inválido|Não deve ser informado quando a Categoria é Aplicável a todos os Clientes",
  "CategoriaCliente.ui.filtroNome": "Nome",
  "CategoriaCliente.ui.filtroNomeGrupoClienteAplicavel": "Grupo Cliente Aplicável",
  "CategoriaClienteDTO.grupoClienteAplicavel": "Grupo de Cliente Aplicável",
  "CategoriaCliente.ui.chooser.nome": "Nome",
  "FonteDadosArquivoEvento": "FonteDadosArquivoEvento",
  "FonteDadosArquivoEvento.fonteDadosArquivo": "Arquivo de Fonte de Dados|Arquivo de Fonte de Dados relacionado ao evento",
  "FonteDadosArquivoEvento.tipo": "Tipo|Tipo do evento de Arquivo de Fonte de Dados",
  "FonteDadosArquivoEvento.tipo.A": "Recebimento",
  "FonteDadosArquivoEvento.tipo.B": "Processamento: Sucesso",
  "FonteDadosArquivoEvento.tipo.C": "Processamento: Erro",
  "FonteDadosArquivoEvento.dataHora": "Data Hora|Data e Hora de ocorrência do evento",
  "FonteDadosArquivoEvento.processamentoErro": "Erro Processamento|Detalhes do Erro de processamento do arquivo, quando o evento for Erro de Processamento"
}